// Dashboard Events summary page translations (en-US), loaded into dashboard.events.summary by ../en-US.events.js
module.exports = {
  menu: "Summary",
  title: "Events Summary",
  description: "The indicators of the former “Events” tab, now with comparison and trend.",
  kpis: {
    total: "Total",
    promoted: "Promoted",
    clicks: "Clicks",
    active: "Active",
    shared: "Shared",
    newEvents: "New",
    linkClicks: "Event link clicks",
    perDay: "Average created per day",
    topCategory: "Top category",
    topContinent: "Top continent",
  },
  info: {
    total: "Events created from the start up to the end of the period, deleted ones included.\nSource: Firebase (event counters).",
    promoted: "Events promoted in the period.\nSource: Firebase (event counters).",
    clicks: "Clicks on event links in the period.\nSource: Firebase (event counters).",
    active: "Active events running on the last day of the period.\nSource: Firebase (events).",
    shared: "Events shared in the period.\nSource: Firebase (event counters).",
    newEvents: "Events created in the period.\nSource: Firebase (event counters).",
    linkClicks: "Clicks on event links in the period (the same number as Clicks, without the age split).\nSource: Firebase (event counters).",
    perDay: "Average events created per day in the period.\nSource: Firebase (event counters).",
    topCategory: "Category with the most active events on the last day of the period.\nSource: Firebase (events).",
    topContinent: "Continent with the most active events on the last day of the period.\nSource: Firebase (events).",
  },
  hints: {
    oneDay: "one-day period",
    ofActive: "{pct} of active",
  },
  modals: {
    total: {title: "Total events"},
    promoted: {title: "Promoted events", subtitle: "by age range"},
    clicks: {title: "Event clicks", subtitle: "by age range"},
    active: {title: "Active events", subtitle: "daily average of active events"},
    shared: {title: "Shared events", subtitle: "by age range"},
    newEvents: {title: "Created events"},
  },
  totalSeries: "Total",
  continents: {
    europe: "Europe",
    southAmerica: "South America",
    northAmerica: "North America",
    africa: "Africa",
    asia: "Asia",
    oceania: "Oceania",
  },
  panels: {
    map: "Events around the world",
    mapNote: "Active events that took place on any day of the period",
  },
  panelInfo: {
    map: "Active events running on some day of the period, by place.\nSource: Firebase (events).",
  },
};
